import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ShelterIndexPropTypes } from 'dpl/shared/utils/customPropTypes';
import { get, isEmpty } from 'dpl/shared/utils/object';
import { debounce } from 'dpl/shared/utils';
import Map from 'dpl/shelter_search_results/components/Map';
import ResultsList from 'dpl/shelter_search_results/components/ResultsList';
import DetailsContainer from 'dpl/shelter_search_results/containers/DetailsContainer';
import EmptyResults from 'dpl/shelter_search_results/components/EmptyResults';
import DetailsCloseButton from 'dpl/shelter_search_results/components/DetailsCloseButton';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

const VERTICAL_PADDING = 24;
const HEIGHT_SUBTRAHEND = VERTICAL_PADDING * 2;

export default class Results extends Component {
  static propTypes = {
    currentPage: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    mapIsLoaded: PropTypes.bool.isRequired,
    onMapLoad: PropTypes.func.isRequired,
    onMapUpdate: PropTypes.func.isRequired,
    onShelterClick: PropTypes.func.isRequired,
    onShelterClose: PropTypes.func.isRequired,
    query: PropTypes.shape({
      location: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      bounding_box: PropTypes.object,
      coordinates: PropTypes.shape({
        formatted_address: PropTypes.string
      })
    }),
    setPage: PropTypes.func.isRequired,
    sheltersData: PropTypes.shape({
      meta: PropTypes.shape({
        isSuccess: PropTypes.bool
      }),
      value: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.shape(ShelterIndexPropTypes))
          .isRequired,
        meta: PropTypes.shape({
          total_item_count: PropTypes.number
        })
      }).isRequired
    }).isRequired,
    shelterId: PropTypes.number
  };

  static defaultProps = {
    query: {},
    shelterId: null
  };

  state = { sidebarHeight: '' };

  setHeight = () =>
    this.setState({
      isReady: true,
      sidebarHeight: `${window.innerHeight - HEIGHT_SUBTRAHEND}px`
    });

  handleResize = debounce(() => {
    this.setHeight();
  }, 500);

  componentDidMount() {
    this.setHeight();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    const {
      currentPage,
      itemsPerPage,
      mapIsLoaded,
      onMapLoad,
      onMapUpdate,
      onShelterClick,
      onShelterClose,
      query,
      setPage,
      shelterId,
      sheltersData
    } = this.props;

    const { isReady, sidebarHeight } = this.state;

    const isMapQuery = !isEmpty(query.bounding_box || {});
    const locationQuery =
      query.location || get(query, 'coordinates.formatted_address');

    const {
      meta: { isSuccess },
      value: {
        data: shelters,
        meta: { total_item_count: totalShelters }
      }
    } = sheltersData;

    const isShelterShown = Boolean(shelterId);

    return (
      <div className="ShelterResults">
        <div className="pv8 container">
          <div className="row">
            <LoadingWrapper isLoading={!isMapQuery && !isSuccess}>
              {!isMapQuery && totalShelters < 1 && (
                <EmptyResults locationQuery={locationQuery} />
              )}
              {(isMapQuery || totalShelters >= 1) && (
                <Fragment>
                  <div className="col-7 col-xl-6">
                    <ResultsList
                      currentPage={currentPage}
                      itemsPerPage={itemsPerPage}
                      mapIsLoaded={mapIsLoaded}
                      onShelterClick={onShelterClick}
                      onShelterClose={onShelterClose}
                      selectedShelterId={shelterId}
                      setPage={setPage}
                      sheltersData={sheltersData}
                    />
                  </div>
                  <div className="col-5 col-xl-6">
                    {isReady && (
                      <div className="h-100">
                        <div
                          className="ShelterResults__sidebar sticky top-2 overflow-x-hidden z-1"
                          style={{ height: sidebarHeight }}
                        >
                          <div
                            className={classnames('h-100 transition', {
                              'o-0': isShelterShown
                            })}
                          >
                            <div className="h-100 flex flex-column">
                              <div className="h-100 flex-auto">
                                <Map
                                  mapIsLoaded={mapIsLoaded}
                                  onMapLoad={onMapLoad}
                                  onMapUpdate={onMapUpdate}
                                  onMarkerClick={onShelterClick}
                                  shelters={shelters}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className={classnames(
                              'ShelterDetailsWrapper transition w-100 h-100 absolute top-0 z-999 bg-white',
                              { 'transform-hide-x-l': !isShelterShown }
                            )}
                          >
                            {isShelterShown && (
                              <div className="h-100 flex flex-column">
                                <DetailsCloseButton onClick={onShelterClose} />
                                <div className="flex-auto ba-l b--light-gray br1 overflow-y-auto">
                                  <DetailsContainer
                                    shelterId={shelterId}
                                    onShelterClose={onShelterClose}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Fragment>
              )}
            </LoadingWrapper>
          </div>
        </div>
      </div>
    );
  }
}
